function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M0.462,21.883C0.192,21.826,0,21.59,0,21.32C0,11.97,11.1,9.98,13.675,9.644V5.355c0-0.211,0.117-0.406,0.306-0.504 c0.188-0.1,0.413-0.086,0.588,0.027l11.858,7.984c0.156,0.105,0.25,0.281,0.25,0.477c0,0.189-0.094,0.365-0.25,0.473l-11.854,7.983 c-0.176,0.115-0.402,0.127-0.59,0.029c-0.188-0.1-0.303-0.297-0.303-0.506v-4.617c-1.867,0.014-3.409,0.098-4.696,0.252 c-6.166,0.729-7.813,4.432-7.883,4.59l0,0c-0.093,0.213-0.302,0.35-0.526,0.35C0.538,21.892,0.497,21.89,0.462,21.883z"
}), React.createElement("g", null), React.createElement("g", null), React.createElement("g", null), React.createElement("g", null), React.createElement("g", null), React.createElement("g", null), React.createElement("g", null), React.createElement("g", null), React.createElement("g", null), React.createElement("g", null), React.createElement("g", null), React.createElement("g", null), React.createElement("g", null), React.createElement("g", null), React.createElement("g", null));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgRedo2 = function SvgRedo2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.677 26.677",
    style: {
      enableBackground: "new 0 0 26.677 26.677"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRedo2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/redo-2.814ff128.svg";
export { ForwardRef as ReactComponent };